import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from './store';

import { HashRouter as Router, Route } from 'react-router-dom';

import base from './containers/HOC/Base';
import noAuth from './containers/HOC/NoAuth';

import { initApp } from './actions'

// CONTAINER COM BASE
import Pedidos from './containers/Pedidos';

import Entregas from './containers/Entregas';
import Entrega from './containers/Entrega';
import Entregadores from './containers/Entregadores';
import NovoEntregador from './containers/Entregadores/novoEntregador';
import ImportarEntregadoresLote from './containers/Entregadores/importarEntregadoresLote';

import Clientes from './containers/Clientes';
import Cliente from './containers/Cliente';
import NewClient from './containers/Clientes/newclient';
import CarrinhosAbandonados from './containers/CarrinhosAbandonados';

import Categorias from './containers/Categorias';
import Categoria from './containers/Categoria';
import NovaCategoria from './containers/Categorias/novaCategoria';

import Produtos from './containers/Produtos';
import Produto from './containers/Produto';

import Avaliacoes from './containers/Avaliacoes';
import Avaliacao from './containers/Avaliacao';

import Reports from './containers/Reports';
import Dashboard from './containers/Dashboard';

import Configuracoes from './containers/Configuracoes';
import Perfil from './containers/Perfil';
import Usuarios from './containers/Usuarios';
import FormularioUsuario from './containers/Usuarios/FormularioUsuario';

import Upsells from './containers/Upsells';
import Upsell from './containers/Upsell';
import NovoUpsell from './containers/Upsells/novoUpsell';

// CONTAINER SEM BASE
import Login from './containers/Login';
import RecuperarSenha from './containers/RecuperarSenha';
import ResetarSenha from './containers/RecuperarSenha/ResetarSenha';

import NewOrder from './containers/NewOrder';
import NovoProduto from './containers/Produtos/novoProduto';

import EmailMarketing from './containers/EmailMarketing';

import GoogleApplications from './containers/GoogleApplications';

import DeliveryConfirmation from './containers/DeliveryConfirmation';
import AssignDelivery from './containers/AssignDelivery';
import AssignDeliveryLanding from './containers/AssignDelivery/Landing';

class App extends Component {

  componentDidMount(){
    initApp();
  }

  render(){
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Route path={"/delivery-confirmation/:token"} exact component={DeliveryConfirmation}/>
            <Route path={"/confirmacao-entrega/:token"} exact component={DeliveryConfirmation}/>
            <Route path={"/assign-delivery"} exact component={AssignDeliveryLanding}/>
            <Route path={"/assign-delivery/:entregaId"} exact component={AssignDelivery}/>

            <Route path={"/"} exact component={base(Pedidos)}/>
            <Route path={"/dashboard"} exact component={base(Dashboard)}/>

            <Route path={"/entregas"} exact component={base(Entregas)}/>
            <Route path={"/entregadores/importar"} exact component={base(ImportarEntregadoresLote)}/>
            <Route path={"/entregadores/novo"} exact component={base(NovoEntregador)}/>
            <Route path={"/entregadores/:id/edit"} exact component={base(NovoEntregador)}/>
            <Route path={"/entregadores"} exact component={base(Entregadores)}/>
            <Route path={"/entrega/:id"} exact component={base(Entrega)}/>

            <Route path={"/clientes"} exact component={base(Clientes)}/>
            <Route path={"/carrinhos-abandonados"} exact component={base(CarrinhosAbandonados)}/>
            <Route path={"/cliente/:id"} exact component={base(Cliente)}/>
            <Route path={"/newclient"} exact component={base(NewClient)}/>

            <Route path={"/categorias"} exact component={base(Categorias)}/>
            <Route path={"/categoria/:id"} exact component={base(Categoria)}/>

            <Route path={"/produtos"} exact component={base(Produtos)}/>
            <Route path={"/produto/:id"} exact component={base(Produto)}/>

            <Route path={"/upsells"} exact component={base(Upsells)}/>
            <Route path={"/upsell/:id"} exact component={base(Upsell)}/>
            
            <Route path={"/avaliacoes/:id"} exact component={base(Avaliacoes)}/>
            <Route path={"/avaliacao/:id"} exact component={base(Avaliacao)}/>

            <Route path={"/configuracoes"} exact component={base(Configuracoes)}/>
            <Route path={"/usuarios/novo"} exact component={base(FormularioUsuario)}/>
            <Route path={"/usuarios/:id/edit"} exact component={base(FormularioUsuario)}/>
            <Route path={"/usuarios"} exact component={base(Usuarios)}/>
            <Route path={"/perfil"} exact component={base(Perfil)}/>
            
            <Route path={"/login"} exact component={noAuth(Login)}/>
            <Route path={"/recuperar-senha"} exact component={noAuth(RecuperarSenha)}/>
            <Route path={"/resetar-senha/:token"} exact component={noAuth(ResetarSenha)}/>

            <Route path={"/neworder"} exact component={base(NewOrder)}/>
            <Route path={"/newproduct"} exact component={base(NovoProduto)}/>
            <Route path={"/newcategory"} exact component={base(NovaCategoria)}/>
            <Route path={"/newupsell"} exact component={base(NovoUpsell)}/>

            <Route path={"/reports"} exact component={base(Reports)}/>
            <Route path={"/email-marketing"} exact component={base(EmailMarketing)}/>
            <Route path={"/google-applications"} exact component={base(GoogleApplications)}/>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;